<template>
  <div>
    <input
      class="modal-state"
      id="activation-code-modal"
      type="checkbox"
      @input="$emit('input', !!$event.target.checked)"
      :checked="value"
    />
    <div class="modal">
      <label
        class="modal__bg"
        for="activation-code-modal"
      ></label>
      <div class="modal__inner">
        <label
          class="modal__close"
          for="activation-code-modal"
        ></label>
        <div
          class="h-full w-full flex flex-col items-center justify-between"
        >
          <div class="mt-2 text-lg text-gray-900 font-bold">
            Use Activation Code
          </div>

          <div class="w-full">
            <input
              name="activationCode"
              type="text"
              required
              class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
              placeholder="Activation Code"
              v-model="activationCode"
              @keyup.enter="doActivate()"
              autofocus
            />
            <button
              @click="doActivate()"
              type="button"
              class="btn-blue w-full my-3"
              :disabled="loading || !this.activationCode"
            >
              Activate
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as Sentry from '@sentry/browser';
import ActivationCodeService from './activation-code-service';

export default {
  name: 'app-activation-code-modal',
  props: ['value'],
  data() {
    return {
      loading: false,
      activationCode: '',
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
  },
  methods: {
    async doActivate() {
      const activationCode = (
        this.activationCode || ''
      ).trim();
      if (this.loading || !activationCode) {
        return;
      }

      try {
        this.loading = true;
        await ActivationCodeService.activate(
          activationCode,
        );
        alert('Subscription activated!');
        this.$emit('input', false);
        this.loading = false;
      } catch (error) {
        Sentry.captureException(error);

        if (
          error &&
          error.response &&
          error.response.status === 400
        ) {
          alert('Invalid activation code');
          this.loading = false;
          this.activationCode = null;
          return;
        }

        alert(
          'Ops, an error occured. Please try again later.',
        );
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: left;
  background: rgba(0, 0, 0, 0.9);
  z-index: 2;
  transition: opacity 0.25s ease;
}

.modal__bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
}

.modal-state {
  display: none;
}

.modal-state:checked + .modal {
  opacity: 1;
  visibility: visible;
}

.modal-state:checked + .modal .modal__inner {
  top: 0;
}

.modal__inner {
  transition: top 0.25s ease;
  position: absolute;
  top: -20%;
  right: 0;
  bottom: 0;
  left: 0;
  width: 40%;
  margin: auto;
  overflow: auto;
  background: #fff;
  border-radius: 5px;
  padding: 1em 2em;
  height: 180px;
}

.modal__close {
  position: absolute;
  right: 1em;
  top: 1em;
  width: 1.1em;
  height: 1.1em;
  cursor: pointer;
}

.modal__close:after,
.modal__close:before {
  content: '';
  position: absolute;
  width: 2px;
  height: 1.5em;
  background: #ccc;
  display: block;
  transform: rotate(45deg);
  left: 50%;
  margin: -3px 0 0 -1px;
  top: 0;
}

.modal__close:hover:after,
.modal__close:hover:before {
  background: #aaa;
}

.modal__close:before {
  transform: rotate(-45deg);
}

@media screen and (max-width: 992px) {
  .modal__inner {
    width: 50%;
    height: 240px;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 768px) {
  .modal__inner {
    width: 90%;
    height: 240px;
    box-sizing: border-box;
  }
}
</style>
